import {
  SET_LANGUAGES_AVAILABLE,
  SET_LANGUAGES_TESTGROUP,
  SET_TESTGROUP_ADVANCED_SETTING,
  SET_TESTGROUP_THEME_TOGGLE,
  SET_TESTGROUP_TO_TRANSLATE,
  SET_TRANSLATE_TEST,
  SET_TRANSLATE_TESTGROUP_LOADING,
  SET_TRANSLATED_TESTS,
} from '../actionTypes';

export const setTestgroupToTranslate = (testgroupTranslated) => ({
  type: SET_TESTGROUP_TO_TRANSLATE,
  payload: { testgroupTranslated },
});

export const setTranslateTest = (testToTranslate) => ({
  type: SET_TRANSLATE_TEST,
  payload: { testToTranslate },
});

export const setTranslateTestgroupLoading = (isLoading) => ({
  type: SET_TRANSLATE_TESTGROUP_LOADING,
  payload: isLoading,
});

export const setLanguagesTestgroup = (data) => ({
  type: SET_LANGUAGES_TESTGROUP,
  payload: data,
});

export const setTranslatedTests = (translatedTests) => ({
  type: SET_TRANSLATED_TESTS,
  payload: {
    translatedTests,
  },
});

export const setLanguagesAvailable = (languagesAvailable) => ({
  type: SET_LANGUAGES_AVAILABLE,
  payload: languagesAvailable,
});

export const setTestgroupWithTheme = (value) => ({
  type: SET_TESTGROUP_THEME_TOGGLE,
  payload: {
    testgroupWithThemes: value,
  },
});

export const setTestgroupAdvancedSetting = (value) => ({
  type: SET_TESTGROUP_ADVANCED_SETTING,
  payload: {
    advancedSetting: value,
  },
});
